import React from 'react'

import { LazyLoadImage } from 'react-lazy-load-image-component'

import { ArrowForwardIcon } from 'images'

const InstagramLinkComponent = (props) => {
  const {card, onLoaded, callToAction, type} = props
  
  if (!card || !card.media?.url) return null
  
  return (
    <>
      <div className="instagram__link carousel-preview-item">
        {card.media?.type?.includes('video') ? (
          <video
            className="instagram__link_media"
            src={card.media.url}
            autoPlay
            loop
            muted
            playsInline
            onLoad={onLoaded}
          />
        ) : (
          <LazyLoadImage
            className="instagram__link_media"
            src={card.media.url}
            alt={card.media.filename}
            width={card.media.width}
            height={card.media.height}
            onLoad={onLoaded}
          />
        )}
        {type === 'instagram' && <div className="instagram__link_order-now">
          <span>{callToAction}</span>
          <span>
            <ArrowForwardIcon />
          </span>
        </div>}
      </div>

      <div className="divider" />
    </>
  )
}

export default InstagramLinkComponent